import React, { useRef, useImperativeHandle } from "react";
import { Grid } from "@mui/material";
import { TextField, SelectField, MenuItem, Button, Stack } from "@curves/ui-base";

const TemporariesOverviewSearchBar = React.forwardRef((props, ref) => {
	const { sourceData: q, options = {} } = props;
	const paramsData = q || {};
	const { customerTypeOptions = [] } = options || {};
	const customerTypeRef = useRef(null);
	const nameRef = useRef(null);

	const getParams = () => {
		let result = {};

		if (nameRef.current && nameRef.current.getResult) {
			Object.assign(result, { name: nameRef.current.getResult() });
		}

		if (customerTypeRef.current && customerTypeRef.current.getResult) {
			Object.assign(result, { customerType: customerTypeRef.current.getResult() });
		}

		return result;
	};

	useImperativeHandle(
		ref,
		() => {
			return {
				getResult: () => getParams(),
			};
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<Grid container spacing={2}>
			<Grid xs={6} item>
				<TextField
					key={paramsData.name}
					ref={nameRef}
					defaultValue={paramsData.name}
					InputProps={{
						placeholder: "請輸入標題",
					}}
					fullWidth
				/>
			</Grid>
			<Grid xs={6} item>
				<SelectField key={paramsData.validType} ref={customerTypeRef} defaultValue={paramsData.validType || 2} fullWidth>
					{customerTypeOptions.map(({ text, value, disabled }) => (
						<MenuItem value={value} key={text} disabled={disabled}>
							{text}
						</MenuItem>
					))}
				</SelectField>
			</Grid>
			<Grid xs={12} item>
				<Stack justifyContent="end">
					<Button type="submit" variant="contained">
						搜尋
					</Button>
				</Stack>
			</Grid>
		</Grid>
	);
});

export default TemporariesOverviewSearchBar;
